/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
} from '@material-ui/core';
import React from 'react';

export const RadioGroupComponentDLP = ({
  data = [],
  value = '',
  onChange = () => {},
  disabled = false,
  disabledValues = [],
  radioGroupClassName = '',
  labelClassName = '',
}) => {
  return (
    <div className='sub-radio no-margin'>
      <FormControl>
        <RadioGroup
          row
          value={value}
          onChange={onChange}
          className={`${radioGroupClassName}`}
        >
          {data.map((item, index) => {
            const optionDisabled =
              disabled ||
              (Array.isArray(disabledValues) &&
                disabledValues.includes(item.value));

            return (
              <FormControlLabel
                value={item.value}
                control={<Radio />}
                label={item.name}
                id={item.value}
                key={index}
                disabled={optionDisabled}
                className={index > 0 ? labelClassName : ''}
              />
            );
          })}
        </RadioGroup>
      </FormControl>
    </div>
  );
};

//export default RadioGroupComponentDLP;
